module.exports = __webpack_public_path__ + "img/home-7.0dc2b4fe.webp";